<template>
    <div class="d-flex flex-column h-100 container">
        <loading ref="loading"></loading>
        <local-error v-bind:inline='[]'></local-error>
        

    </div>
</template>

<script>
    export default {
        props: [

        ],
        data: function(){
            return {
                errors: [],
                campaign_id: null,
                user_id: null,
            };
        },
        mounted() {
            this.campaign_id = this.$route.params["campaign_id"];
            this.user_id = this.$route.params["user_id"];

            if(this.user_id != this.$root.user.id) {
                window.api_token = null;
                this.$root.api_token = window.api_token;

                if(window.Echo) {
                    delete window.Echo.connector.options.auth.headers['Authorization'];
                    delete axios.defaults.headers.common['Authorization'];
                }
                
                axios.get('/logout')
                .finally(() => {
                    this.setLoading(false);
                    app.$root.$router.push({path: "/login/" + encodeURIComponent(`/campaign/${this.$route.params.campaign_id}/${this.$route.params.user_id}`)});
                });
            }
            else {
                this.getCampaign();
            }
        },
        computed: {
            
        },
        watch: {

        },
        methods: {
            getCampaign(id) {
                this.setLoading(true);

                axios.get(`${this.$root.apiBase}/campaigns/user/${this.campaign_id}/${this.user_id}`).then((res) => {
                    this.campaign_user_xref = res.data["campaign_user_xref"];
                    var data = {
                        campaign_id: this.campaign_user_xref.campaign.id,
                    }
                    if(this.campaign_user_xref.campaign.custom_action.form_id) {
                        
                        axios.post(this.$root.apiBase + "/formsubmissions/from_campaign", data).then((res) => {
                            this.setLoading(false);
                            console.info(res.data);
                            if(res.data.submitted_at) {
                                this.$router.push({path: "/thread-show/" + res.data.message.thread_id});    
                            }
                            else {
                                this.$router.push({path: "/form-submission/" + res.data.id});
                            }
                        }).catch((error) => {
                            this.setLoading(false);
                            this.addNotification({type: "danger", content: this.$t('translations.couldnt_load_form')});
                            this.$router.push({path: "/profile"});
                        });
                        
                    }
                    else {
                        // HERE Do we need to check if the user has already followed the link and stop them doing it again?
                        // Do we record the completion just the first time they visit, or every time?
                        axios.post(this.$root.apiBase + "/campaigns/complete_user/" + this.campaign_user_xref.campaign.id, {}).then((res) => {
                            this.setLoading(false);
                            Vue.nextTick(() => {
                                window.location = this.campaign_user_xref.campaign.custom_action.url
                            });
                        }).catch((error) => {
                            this.setLoading(false);
                            this.addNotification({type: "danger", content: this.$t('translations.couldnt_load_form')});
                            this.$router.push({path: "/profile"});
                        });
                        
                    }
                    this.$router.push({path: "/intro"});
                    this.setLoading(false);
				}).catch((error) => {
                    this.setLoading(false);
                    this.injectFieldErrors("campaign", "translations.campaign_not_found");
                    this.handleError(error, "load");
                    this.$router.push({path: "/profile"});
                });
            },
        }
    }

</script>
